import { combineReducers } from 'redux'
import DeleteAppointmentMainReducer from './appointments.delete.main.reducer'
import DeletePaidAppointmentReducer from './appointments.delete.paid.reducer'

const DeleteAppointmentReducer = combineReducers({
  main: DeleteAppointmentMainReducer,
  paid: DeletePaidAppointmentReducer,
})

export default DeleteAppointmentReducer